import { createSmartAccountClient, } from "@alchemy/aa-core";
import {} from "viem";
import { createLightAccount, } from "../accounts/account.js";
import { lightAccountClientActions, } from "../decorators/lightAccount.js";
export async function createLightAccountClient({ account, transport, chain, ...clientConfig }) {
    const lightAccount = await createLightAccount({
        ...account,
        transport,
        chain,
    });
    return createSmartAccountClient({
        ...clientConfig,
        transport,
        chain: chain,
        account: lightAccount,
    }).extend(lightAccountClientActions);
}
//# sourceMappingURL=lightAccount.js.map